import script from "./PageSubnav.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageSubnav.vue?vue&type=script&setup=true&lang=ts"

import "./PageSubnav.vue?vue&type=style&index=0&id=7a70f6a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a70f6a0"]])

export default __exports__